/* Design fixes 2026-10-24.
   1. Keeps body.tc-tray-empty in sync with the cart so the sticky tray hides while empty and the chat button only lifts
      when the tray is showing. tenchi.js fires `tenchi:cart` after every cart change.
   2. body.tc-rx-ok mirrors the practitioner confirmation, so express checkout buttons stay hidden until it's ticked.
   3. Stats row: staggered rise + count-up when the row is half in view (takes over from tenchi.js's count-up). */
(function () {
  var body = document.body;
  function sync(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    body.classList.toggle('tc-tray-empty', cart.item_count === 0);
    var attrs = cart.attributes || {};
    body.classList.toggle('tc-rx-ok', attrs['Practitioner confirmation'] === 'Yes');
  }
  document.addEventListener('tenchi:cart', function (e) {
    sync(e.detail);
  });
  // Back/forward cache can restore a stale class; re-read the cart when the page is shown again.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !window.fetch) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(sync)
      .catch(function () {});
  });

  var root = document.querySelector('[data-tc-proof]');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!root || reduce || !('IntersectionObserver' in window)) return;
  var cells = Array.prototype.slice.call(root.querySelectorAll('.proof__stats > li'));
  if (!cells.length) return;
  // Swap each counter for a fresh copy without data-tc-count, so tenchi.js's own count-up can't run on it.
  root.querySelectorAll('[data-tc-count]').forEach(function (el) {
    var c = el.cloneNode(true);
    c.setAttribute('data-fx-count', el.getAttribute('data-tc-count'));
    c.setAttribute('data-fx-dec', el.getAttribute('data-tc-dec') || '0');
    c.setAttribute('data-fx-suffix', el.getAttribute('data-tc-suffix') || '');
    c.removeAttribute('data-tc-count');
    el.replaceWith(c);
  });
  root.classList.add('proof--anim');
  function count(el) {
    var to = Number(el.getAttribute('data-fx-count'));
    var dec = Number(el.getAttribute('data-fx-dec'));
    var suf = el.getAttribute('data-fx-suffix');
    if (!isFinite(to)) return;
    var fmt = function (n) { return (dec ? n.toFixed(dec) : String(Math.round(n))) + suf; };
    var t0 = performance.now(), dur = 1300;
    el.textContent = fmt(0);
    (function tick(now) {
      var p = Math.min(1, (now - t0) / dur);
      el.textContent = fmt(to * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(tick); else el.textContent = fmt(to);
    })(t0);
  }
  var io = new IntersectionObserver(function (entries) {
    if (!entries.some(function (en) { return en.isIntersecting; })) return;
    io.disconnect();
    cells.forEach(function (li, i) {
      setTimeout(function () {
        li.classList.add('is-in');
        var n = li.querySelector('[data-fx-count]');
        if (n) count(n);
      }, 120 + i * 160);
    });
  }, { threshold: 0.5 });
  io.observe(root);

  // Facts strip under it: same staggered rise.
  var facts = document.querySelector('ul.facts');
  if (facts) {
    var items = Array.prototype.slice.call(facts.children);
    facts.classList.add('fx-anim');
    var io2 = new IntersectionObserver(function (entries) {
      if (!entries.some(function (en) { return en.isIntersecting; })) return;
      io2.disconnect();
      items.forEach(function (li, i) {
        setTimeout(function () { li.classList.add('is-in'); }, 80 + i * 140);
      });
    }, { threshold: 0.5 });
    io2.observe(facts);
  }
})();

/* Packs sold as their own product (Shopify bundles): add the pack product, then refresh and open the tray. */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-tc-bundle-add]');
  if (!b || b.disabled) return;
  e.preventDefault();
  b.disabled = true;
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-vid')), quantity: 1 }] }) })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (window.Tenchi && Tenchi.refresh) return Promise.resolve(Tenchi.refresh()).then(function () { if (Tenchi.openTray) Tenchi.openTray(); });
      location.href = root + 'cart';
    })
    .catch(function () { location.href = root + 'cart'; })
    .then(function () { b.disabled = false; });
});

/* Title motion. Plain text stays in the DOM; only wrappers are added. Skipped for Reduce Motion. */
(function () {
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var h1 = document.querySelector('.hero h1');
  if (h1 && !h1.dataset.tl) {
    h1.dataset.tl = '1';
    var parts = h1.textContent.replace(/\s+/g, ' ').trim().split(/(?<=\.)\s+/);
    h1.textContent = '';
    parts.forEach(function (t, i) {
      var line = document.createElement('span');
      line.className = 'tl-line';
      var inner = document.createElement('span');
      inner.textContent = t;
      inner.style.transitionDelay = (i * 0.12) + 's';
      if (/one price/i.test(t)) inner.className = 'tl-gauge';
      line.appendChild(inner);
      h1.appendChild(line);
      if (i < parts.length - 1) h1.appendChild(document.createTextNode(' '));
    });
    requestAnimationFrame(function () { requestAnimationFrame(function () { h1.classList.add('tl-on'); }); });
  }
  if (!('IntersectionObserver' in window)) return;
  var heads = document.querySelectorAll('.sec__h h2, .phead h1');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      en.target.classList.add('tl-on');
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  heads.forEach(function (h) {
    if (h.closest('.hero') || h.dataset.tl) return;
    h.dataset.tl = '1';
    var inner = document.createElement('span');
    while (h.firstChild) inner.appendChild(h.firstChild);
    h.appendChild(inner);
    h.classList.add('tl-sec');
    io.observe(h);
  });
})();

